<div class="container">
  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img  src="../../../../assets/images/banners/ad-sm.png" class="carousel-img w-100" alt="...">
      </div>
      <div class="carousel-item">
        <img  src="https://i.pinimg.com/originals/d7/3f/8c/d73f8c9c1073585858a0a4abb519d1b5.jpg" class="carousel-img d-block w-100" alt="...">
      </div>
      <div class="carousel-item">
        <img  src="https://4.bp.blogspot.com/-_hZid1rqRaw/WLpqg3JVBFI/AAAAAAAAAOM/P7jv1QzqvE0MrdFAHlVTd7w9LbibFw5bACLcB/s1600/Camera.jpg" class="carousel-img d-block w-100" alt="...">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
  
  <div class="cards">
<div class="col-md-12">
  <div class="row no-gutters">
    <div class="col-6 col-lg-3 col-md-4" style="padding-right: 20px;" *ngFor="
              let product of productList | paginate:{ id: 'camp_pagination', itemsPerPage:12,currentPage :page ,totalItems:totalrecords}">
      <div class="item">
        <div class="mb-r">
          <!--Card-->
          <div class="card card-cascade wider">
            <!--Card image-->
            <a routerLink="productDetails/{{product.id}}">
              <div width="360px" height="40px" class="view overlay hm-white-slight">
                <img class = "img-sm float-right" [src]="product.image" class="img-fluid" alt="" width="360px" height="440px" />
                <!-- <a>
                  <div class="mask waves-effect waves-light" mdbRippleRadius></div>
                </a> -->
              </div>
            </a>
            <!--/.Card image-->
            <!--Card content-->
            <div class="card-body text-center no-padding">
              <!--Category & Title-->
              <a class="category">
                <h5>{{ product.category }}</h5>
              </a>
              <p class="card-title">
                <strong>
                  <a routerLink="productDetails/{{product.id}}"
                    routerLinkActive="router-link-active">{{ product.title }}</a>
                </strong>
              </p>
              <!--Description-->
              <!--Card footer-->
              <div class="card-footer">
                <span class="left">{{ product.price | currency: ('CURRENCY.VALUE' | translate)}}</span>
                <span class="right">
                  <a class= "addtocart"(click)="addToCart(product.id)">
                    <i class="fa fa-shopping-cart fa-lg" style="color: #2199e8; size: 100px;"></i>
                    <span class="tooltiptext">Add To Cart</span>
                  </a>
                </span>
              </div>
            </div>
            <!--/.Card content-->
          </div>
          <!--/.Card-->
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="page">
  <pagination-controls id = "camp_pagination" maxSize="5" directionLinks="true" (pageChange) = "page = $event"></pagination-controls>
</div>
</div>
<!-- <div class="col-md-12">

  <div class="card">
    <p-dataView #dv [value]="productList" [paginator]="true" [rows]="9" filterBy="name" layout="grid">
      <ng-template pTemplate="header">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
          <p-dropdown [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Sort By Price"
            (onChange)="onSortChange($event)" styleClass="p-mb-2 p-mb-md-0"></p-dropdown>
          <span class="p-input-icon-left p-mb-2 p-mb-md-0">
            <i class="pi pi-search"></i>
            <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
          </span>
          <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
        </div> 
      </ng-template> -->
      <!-- <ng-template let-product pTemplate="listItem">
            <div class="p-col-4">
                <div class="product-list-item">
                    <div class="product-list-detail">
                        <div class="product-name">{{product.title}}</div>
                        <div class="product-description">{{product.description}}</div>
                        <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating>
                        <i class="pi pi-tag product-category-icon"></i><span class="product-category">{{product.category}}</span>
                    </div>
                    <div class="product-list-action">
                        <span class="product-price">${{product.price}}</span>
                        <p-button icon="pi pi-shopping-cart" label="Add to Cart" [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"></p-button>
                        <span [class]="'product-badge status-' + product.inventoryStatus.toLowerCase()">{{product.inventoryStatus}}</span>
                    </div>
                </div>
            </div>
        </ng-template> -->
      <!-- <div class="row no-gutters bordered-cols">
        <ng-template let-product pTemplate="gridItem">

          <div class="col-6 col-lg-3 col-md-4">
            <div class="product-grid-item card">
              <div class="product-grid-item-top">
                <div>
                  <i class="pi pi-tag product-category-icon"></i>
                  <span class="product-category">{{product.category}}</span>
                </div>
              </div>
              <div class="product-grid-item-content">
                <img [src]="product.image" [alt]="product.name" />
                <div class="product-name">{{product.title}}</div>
                <div class="product-description">{{product.description}}</div>
                <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating>
              </div>
              <div class="product-grid-item-bottom">
                <span class="product-price">${{product.price}}</span>
                <p-button icon="pi pi-shopping-cart" [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"></p-button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </p-dataView>

  </div> -->
